import React, { Component } from 'react';
import ReactTable from 'react-table';
import _ from 'lodash';
import { Checkbox, Button, Form } from 'semantic-ui-react';
import EditableLabel from 'Components/editableLabel/EditableLabel';
import { VendorEleFileConfigFieldEnum as Fields } from 'Common/FieldEnum';

class EleConfigFieldsContainer extends Component {
  state = {
    checkAllExport: false,
  };

  handleFieldSelected = (value, originalRow) => {
    if (value && value.checked) {
      const fieldSelectedClone = Object.assign([], this.props.input.value);
      let newField = {};
      newField[Fields.FieldInfoId] = originalRow[Fields.Id];
      newField[Fields.OrderId] = fieldSelectedClone
        ? fieldSelectedClone.length + 1
        : 1;
      fieldSelectedClone.push(newField);
      this.props.input.onChange(fieldSelectedClone);
      this.setState({
        checkAllExport:
          this.props.dataSource.length === fieldSelectedClone.length,
      });
    } else {
      const currentFields = this.props.input.value;
      const newFields = [];
      const fieldIndex = _.findIndex(currentFields, originalRow);
      _.each(currentFields, (field, index) => {
        if (fieldIndex !== index) {
          const newFiled = Object.assign({}, field);
          if (fieldIndex < index) {
            newFiled[Fields.OrderId] = newFiled[Fields.OrderId] - 1;
          }
          newFields.push(newFiled);
        }
      });
      this.props.input.onChange(newFields);
      this.setState({
        checkAllExport: false,
      });
    }
  };

  handleFieldLengthChange = (refData, newLength) => {
    const currentFields = this.props.input.value;
    const newFields = [];
    _.each(currentFields, field => {
      const newFiled = Object.assign({}, field);
      if (refData[Fields.Id] === newFiled[Fields.Id]) {
        newFiled[Fields.IdLength] = Number('' + newLength);
      }
      newFields.push(newFiled);
    });
    this.props.input.onChange(newFields);
  };

  onMoveFieldUp = (e, original) => {
    e.preventDefault();
    const currentFields = this.props.input.value;
    const fieldIndex = _.findIndex(currentFields, original);
    const newFields = [];
    _.each(currentFields, (field, index) => {
      const newFiled = Object.assign({}, field);
      if (index === fieldIndex - 1) {
        newFiled[Fields.OrderId] = newFiled[Fields.OrderId] + 1;
      } else if (index === fieldIndex) {
        newFiled[Fields.OrderId] = newFiled[Fields.OrderId] - 1;
      }
      newFields.push(newFiled);
    });
    const orderedNewFields = _.orderBy(newFields, [Fields.OrderId]);
    this.props.input.onChange(orderedNewFields);
  };

  onMoveFieldDown = (e, original) => {
    e.preventDefault();
    const currentFields = this.props.input.value;
    const fieldIndex = _.findIndex(currentFields, original);
    const newFields = [];
    _.each(currentFields, (field, index) => {
      const newFiled = Object.assign({}, field);
      if (index === fieldIndex) {
        newFiled[Fields.OrderId] = newFiled[Fields.OrderId] + 1;
      } else if (index === fieldIndex + 1) {
        newFiled[Fields.OrderId] = newFiled[Fields.OrderId] - 1;
      }
      newFields.push(newFiled);
    });
    const orderedNewFields = _.orderBy(newFields, Fields.OrderId);
    this.props.input.onChange(orderedNewFields);
  };

  handleExportAllClick = data => {
    const currentFields = this.props.input.value;
    const { dataSource } = this.props;
    const newFields = [];
    if (data.checked) {
      _.each(currentFields, field => {
        const newField = Object.assign({}, field);
        newFields.push(newField);
      });
      _.each(dataSource, (field, index) => {
        const existingIndex = _.findIndex(newFields, {
          [Fields.FieldInfoId]: field[Fields.Id],
        });
        if (existingIndex === -1) {
          const newField = Object.assign({}, field);
          newField[Fields.FieldInfoId] = field[Fields.Id];
          newField[Fields.OrderId] = newFields ? newFields.length + 1 : 1;
          newFields.push(newField);
        }
      });
    }
    this.props.input.onChange(newFields);
  };

  getColumns = () => {
    return [
      {
        Header: 'Field',
        accessor: Fields.FieldValue,
        filterable: false,
        resizable: false,
        width: 350,
      },
      {
        Header: () => {
          return (
            <div>
              <Checkbox
                checked={this.state.checkAllExport}
                onClick={(e, data) => {
                  this.setState({
                    checkAllExport: data.checked,
                  });
                  this.handleExportAllClick(data);
                }}
              />{' '}
              <label>Export</label>
            </div>
          );
        },
        Cell: ({ original }) => {
          return (
            <div style={{ textAlign: 'center' }}>
              <Checkbox
                checked={original[Fields.OrderId] > 0}
                onClick={(e, data) => {
                  this.handleFieldSelected(data, original);
                }}
              />
            </div>
          );
        },
        width: 150,
        sortable: false,
      },
      {
        Header: 'Field Length',
        filterable: false,
        resizable: false,
        width: 150,
        Cell: ({ original }) => {
          return (
            <EditableLabel
              label={original[Fields.IdLength] ? original[Fields.IdLength] : ''}
              refData={original}
              onChange={this.handleFieldLengthChange}
              maxLength={2}
              inputType={'number'}
              allowEdit={true}
              disableInput={!original[Fields.OrderId]}
            />
          );
        },
      },
      {
        Header: '',
        id: 'actions',
        sortable: false,
        resizable: false,
        style: { textAlign: 'center' },
        Cell: ({ original }) => {
          return (
            <div>
              <Button
                icon="angle up"
                onClick={e => this.onMoveFieldUp(e, original)}
                disabled={
                  !original[Fields.OrderId] || original[Fields.OrderId] < 2
                }
              />
              <Button
                icon="angle down"
                onClick={e => this.onMoveFieldDown(e, original)}
                disabled={
                  !original[Fields.OrderId] ||
                  !this.props.input.value ||
                  original[Fields.OrderId] >= this.props.input.value.length
                }
              />
            </div>
          );
        },
      },
    ];
  };

  render() {
    const { dataSource } = this.props;
    const { value } = this.props.input;
    const tableData = _.values(
      _.merge(
        _.keyBy(value, Fields.FieldInfoId),
        _.keyBy(dataSource, Fields.Id)
      )
    );
    const tableDataOrdered = _.orderBy(tableData, Fields.OrderId);
    return (
      <Form.Field>
        <ReactTable
          getTdProps={() => ({
            style: {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            },
          })}
          minRows={0}
          columns={this.getColumns()}
          data={tableDataOrdered}
          showPagination={false}
          defaultPageSize={
            tableDataOrdered && Array.isArray(tableDataOrdered)
              ? tableDataOrdered.length
              : 0
          }
          style={{
            height: '400px',
          }}
          sortable={false}
        />
      </Form.Field>
    );
  }
}

export default EleConfigFieldsContainer;



// WEBPACK FOOTER //
// ./src/pages/inventory/vendorsetup/components/EleConfigFields.js